import { RSAA } from 'redux-api-middleware';
import type { RSAACallAction, RSAACallRequest } from '@makemydeal/dr-react-18-wrappers';

import {
    NO_DEAL_ASSOCIATED_WITH_DEALERSHIPS,
    CLEAR_ROLE_ASSUMPTION,
    SAVE_ROLE_ASSUMPTED_USERNAME,
    START_ROLE_ASSUMPTION,
    VALIDATE_ROLE_ASSUMPTION_USER_REQUEST,
    VALIDATE_ROLE_ASSUMPTION_USER_SUCCESS,
    VALIDATE_ROLE_ASSUMPTION_USER_FAILURE,
    RESET_VALIDATION_STATE,
    INITIALIZING_ROLE_ASSUMPTION
} from './actions';

export const clearRoleAssumption = (query: string = '') => {
    return {
        type: CLEAR_ROLE_ASSUMPTION,
        payload: query
    };
};

export const startRoleAssumption = () => {
    return {
        type: START_ROLE_ASSUMPTION
    };
};

export const saveRoleAssumptionUserName = (userName: string) => {
    return {
        type: SAVE_ROLE_ASSUMPTED_USERNAME,
        userName
    };
};

export const checkNoDealAssociatedWithDealerships = (isNoDealAssociated: boolean) => {
    return {
        type: NO_DEAL_ASSOCIATED_WITH_DEALERSHIPS,
        isNoDealAssociated
    };
};

export const resetValidationState = () => {
    return {
        type: RESET_VALIDATION_STATE
    };
};

export const validateRoleAssumptionUser = (bffEndpoint: string) => {
    const endpoint = `${bffEndpoint}`;
    const request: RSAACallRequest = {
        endpoint,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        types: [
            VALIDATE_ROLE_ASSUMPTION_USER_REQUEST,
            VALIDATE_ROLE_ASSUMPTION_USER_SUCCESS,
            VALIDATE_ROLE_ASSUMPTION_USER_FAILURE
        ],
        fetch: async (input: RequestInfo | URL, init?: RequestInit) => await fetch(input, init)
    };
    return {
        [RSAA]: request
    } as RSAACallAction;
};

// Returned by a host's `navigateToDashboard` HostActions slot once the username validates.
// The host's own roleAssumptionMiddleware reacts to this by re-running its existing init/bootstrap
// call as the assumed user (see e.g. apps/accelerate/sales-checkin/.../role-assumption/middleware.ts).
export const initializingRoleAssumption = () => {
    return {
        type: INITIALIZING_ROLE_ASSUMPTION
    };
};
